import React from "react";

interface BadgeProps {
  className?: string;
  variant?: "green" | "red" | "gray" | "orange";
  children: React.ReactNode;
}

const variantClasses = {
    green: "bg-[#E4FCD8] border border-[#C3FBB2] text-[#137D33]",
    red: "bg-[#FDE8E4] border border-[#F5B8B0] text-[#D92D20]",
    gray: "bg-[#F3F4F6] border border-[#D1D5DB] text-[#6B7280]",
    orange: "bg-[#FFF4E5] border border-[#FFCC80] text-[#B45309]",
};


const Badge: React.FC<BadgeProps> = ({ children, className = "", variant = "green" }) => {

  return (
    <span
      className={`rounded-md px-2 text-sm font-medium ${variantClasses[variant]} ${className}`}
    >
      {children}
    </span>
  );
};

export default Badge;
